import * as t from "io-ts"

export const TServiceType = t.interface({
  code: t.string,
  description: t.string
})

export const TServiceTypes = t.array(TServiceType)

export type ServiceType = t.TypeOf<typeof TServiceType>
export type ServiceTypes = t.TypeOf<typeof TServiceTypes>
